import text from "../text";
export const pdfRender = async (arg) => {
    try {
        const { value } = arg;
        // @ts-ignore
        await text.pdf({ ...arg, value: value.text });
    }
    catch (error) {
        console.log(error);
    }
};
//# sourceMappingURL=pdfRender.js.map